// extracted by mini-css-extract-plugin
export default {"container":"UserProfile_container__KAge6","wrapper":"UserProfile_wrapper__DQ9Ji","sidebar":"UserProfile_sidebar__GqmEy","sidebar-body":"UserProfile_sidebar-body__t4SJq"};